module.exports = "/images/sort_both.png?9a6486086d09bb38cf66a57cc559ade3";